import { Cookies } from 'react-cookie';

import DevicesByTokenData from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getDevicesByToken = async (trapsToken: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`devices-by-token/${trapsToken}/`, {
    headers: {
      Authorization: token,
    },
  });

  return data.data as DevicesByTokenData[];
};
